import {css} from 'lit'; export default css`chameleon-banner{height:32px;position:absolute;width:100%}`;
    